// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  gap: 20px;
}

.logo {
  transition: all 0.3s ease;
  cursor: pointer;
}

.logo:hover {
  transform: scale(1.03) translateY(-1px);
}

.logo:hover h1::after {
  width: 100%;
}

.logo:active {
  transform: scale(0.98) translateY(0px);
  transition: all 0.1s ease;
}

.logo h1 {
  font-size: 2.2rem;
  font-weight: 900;
  letter-spacing: 1.2px;
  background: linear-gradient(135deg, #9e2536 0%, #c73951 60%, #d64570 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
  position: relative;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
}

.logo h1::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #9e2536 0%, #c73951 50%, #d64570 100%);
  transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 1px;
}

.logo:hover h1 {
  background: linear-gradient(135deg, #b02e43 0%, #d64570 60%, #e85a87 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  filter: drop-shadow(0 2px 4px rgba(158, 37, 54, 0.15));
}

.nav { display: flex; gap: 16px; align-items: center; }

.link {
  background: transparent;
  border: none;
  color: #4a5568;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 10px;
  border-radius: 6px;
}

.link:hover { background: rgba(158, 37, 54, 0.08); color: #2d3748; }

.cta { display: flex; gap: 12px; align-items: center; }

@media (max-width: 900px) {
  .nav { display: none; }
  
  .header-content {
    padding: 16px 0;
  }
  
  .logo h1 {
    font-size: 1.8rem;
    letter-spacing: 1px;
  }
  
  .cta {
    gap: 8px;
  }
  
  .cta .btn {
    padding: 10px 16px;
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .logo h1 {
    font-size: 1.6rem;
    letter-spacing: 0.8px;
  }
  
  .header-content {
    padding: 12px 0;
    gap: 12px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,iDAAiD;EACjD,iHAAiH;AACnH;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yEAAyE;EACzE,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA,OAAO,aAAa,EAAE,SAAS,EAAE,mBAAmB,EAAE;;AAEtD;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,cAAc,mCAAmC,EAAE,cAAc,EAAE;;AAEnE,OAAO,aAAa,EAAE,SAAS,EAAE,mBAAmB,EAAE;;AAEtD;EACE,OAAO,aAAa,EAAE;;EAEtB;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;AACF","sourcesContent":[".header {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 0;\n  gap: 20px;\n}\n\n.logo {\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.logo:hover {\n  transform: scale(1.03) translateY(-1px);\n}\n\n.logo:hover h1::after {\n  width: 100%;\n}\n\n.logo:active {\n  transform: scale(0.98) translateY(0px);\n  transition: all 0.1s ease;\n}\n\n.logo h1 {\n  font-size: 2.2rem;\n  font-weight: 900;\n  letter-spacing: 1.2px;\n  background: linear-gradient(135deg, #9e2536 0%, #c73951 60%, #d64570 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin: 0;\n  position: relative;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;\n}\n\n.logo h1::after {\n  content: '';\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  width: 0;\n  height: 2px;\n  background: linear-gradient(90deg, #9e2536 0%, #c73951 50%, #d64570 100%);\n  transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  border-radius: 1px;\n}\n\n.logo:hover h1 {\n  background: linear-gradient(135deg, #b02e43 0%, #d64570 60%, #e85a87 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  filter: drop-shadow(0 2px 4px rgba(158, 37, 54, 0.15));\n}\n\n.nav { display: flex; gap: 16px; align-items: center; }\n\n.link {\n  background: transparent;\n  border: none;\n  color: #4a5568;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 8px 10px;\n  border-radius: 6px;\n}\n\n.link:hover { background: rgba(158, 37, 54, 0.08); color: #2d3748; }\n\n.cta { display: flex; gap: 12px; align-items: center; }\n\n@media (max-width: 900px) {\n  .nav { display: none; }\n  \n  .header-content {\n    padding: 16px 0;\n  }\n  \n  .logo h1 {\n    font-size: 1.8rem;\n    letter-spacing: 1px;\n  }\n  \n  .cta {\n    gap: 8px;\n  }\n  \n  .cta .btn {\n    padding: 10px 16px;\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .logo h1 {\n    font-size: 1.6rem;\n    letter-spacing: 0.8px;\n  }\n  \n  .header-content {\n    padding: 12px 0;\n    gap: 12px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
